<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="cancel" @click="$emit('return_modal_cancel_view')" v-if="modal == true" />
      <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />

      <router-link
        :to="{ path: '/f/enrolment/personal/template/' + coursetemplate.uuid + '/course/' + course.uuid }"
        v-if="$can('course-access')"
        target="_blank"
      >
        <action-button type="course_reg_form" />
      </router-link>

      <router-link
        :to="{ path: BACKEND_URL + '/courses/edit/' + course.id, props: { id: course.id } }"
        v-if="$can('course-edit') && modal != true"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(course.id)" v-if="$can('course-delete') && modal != true" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="course.name"
                  v-model="course.name"
                  :label="$t('courses.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-textarea
                  name="course.short_description"
                  v-model="course.short_description"
                  :label="$t('courses.short_description')"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex md6 xs12>
                <v-textarea name="course.description" v-model="course.description" :label="$t('courses.description')" readonly></v-textarea>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.coursetype_id"
                  v-model="coursetype.fullname"
                  :label="$t('coursetypes.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.coursetemplate_id"
                  v-model="coursetemplate.name"
                  :label="$t('coursetemplates.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.class_id"
                  v-model="classes.name"
                  :label="$t('classes.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.instructor_id"
                  v-model="instructor.fullname"
                  :label="$t('courses.instructor_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.address_id"
                  v-model="address.full_address"
                  :label="$t('addresses.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.classroom_id"
                  v-model="classroom.name"
                  :label="$t('classrooms.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.location"
                  v-model="course.location"
                  :label="$t('courses.location')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.start_date"
                  :value="computedCourseStartDate"
                  :label="$t('courses.start_date')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.start_time"
                  :value="computedCourseStartTime"
                  :label="$t('courses.start_time')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.end_date"
                  :value="computedCourseEndDate"
                  :label="$t('courses.end_date')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.end_time"
                  :value="computedCourseEndTime"
                  :label="$t('courses.end_time')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.num_places"
                  v-model="course.num_places"
                  :label="$t('courses.num_places')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="course.status"
                  :value="this.$dd_course_status(course.status)"
                  :label="$t('courses.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox v-model="course.is_published" :label="$t('courses.is_published')" readonly></v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4 xs6">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("moduletemplates.title") }}</v-toolbar-title>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 v-for="moduletemplate in moduletemplates" :key="moduletemplate.id">
                <v-card>
                  <v-card-title class="body-1 mt-card-title">
                    <div class="body-2">{{ moduletemplate.name }}</div>
                    <div class="caption ml-2">({{ $t("moduletemplates.price") }}: {{ moduletemplate.price }})</div>
                    <v-spacer></v-spacer>

                    <action-button
                      type="new"
                      small
                      @click="showForm(null, 'moduleoption', moduletemplate.id, course.coursetemplate_id)"
                      :icon_only="true"
                    />
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">{{ $t("moduleoptions.name") }}</th>
                            <th class="text-left">{{ $t("moduleoptions.coursetemplate_id") }}</th>
                            <th class="text-left">{{ $t("moduleoptions.price") }}</th>
                            <th class="text-left">{{ $t("moduleoptions.hours") }}</th>
                            <th class="text-end" width="20%">{{ $t("global.actions") }}</th>
                          </tr>
                        </thead>
                        <tbody v-for="moduleoption in moduletemplate.module_options" :key="moduleoption.id">
                          <tr>
                            <td scope="row">{{ moduleoption.name }}</td>
                            <td scope="row">
                              {{ moduleoption.course_template ? moduleoption.course_template.name : "" }}
                            </td>
                            <td scope="row">{{ moduleoption.price }}</td>
                            <td scope="row">{{ moduleoption.hours }}</td>
                            <td class="text-end" scope="row">
                              <action-button
                                type="edit"
                                :icon_only="true"
                                small
                                @click="showForm(moduleoption.id, 'moduleoption', moduletemplate.id, course.coursetemplate_id)"
                              />
                              <action-button type="delete" :icon_only="true" small @click="del_option(moduleoption.id)" />
                            </td>
                          </tr>
                          <tr>
                            <td :colspan="5" class="ct-td">
                              <v-card>
                                <v-app-bar flat dense color="white">
                                  <v-toolbar-title class="body-2">{{ $t("coursetypes.title") }}</v-toolbar-title>

                                  <v-spacer></v-spacer>

                                  <action-button
                                    type="new"
                                    small
                                    @click="showForm(null, 'moduleoptioncoursetype', moduleoption.id, course.coursetemplate_id)"
                                    :icon_only="true"
                                  />
                                </v-app-bar>
                                <v-card-text class="pa-4">
                                  <v-simple-table>
                                    <template v-slot:default>
                                      <thead>
                                        <tr>
                                          <th class="text-left">
                                            {{ $t("moduleoptioncoursetypes.coursetype_id") }}
                                          </th>
                                          <th class="text-left">
                                            {{ $t("moduleoptioncoursetypes.name") }}
                                          </th>
                                          <th class="text-left">
                                            {{ $t("moduleoptioncoursetypes.price") }}
                                          </th>
                                          <th class="text-end" width="20%">
                                            {{ $t("global.actions") }}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="coursetype in moduleoption.module_options_course_types" :key="coursetype.id">
                                          <td scope="row">
                                            {{ coursetype.course_type.category }}
                                          </td>
                                          <td scope="row">{{ coursetype.name }}</td>
                                          <td scope="row">{{ coursetype.price }}</td>
                                          <td scope="row" class="text-end">
                                            <action-button
                                              type="edit"
                                              :icon_only="true"
                                              small
                                              @click="
                                                showForm(coursetype.id, 'moduleoptioncoursetype', moduleoption.id, course.coursetemplate_id)
                                              "
                                            />
                                            <action-button type="delete" :icon_only="true" small @click="del_option_ct(coursetype.id)" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                  </v-simple-table>
                                </v-card-text>
                              </v-card>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("attendees.list_title") }}</v-toolbar-title>
          </v-app-bar>

          <v-divider></v-divider>

          <v-card-text>
            <v-flex md12>
              <v-data-table
                :headers="attendee_headers"
                :items="attendees"
                :items-per-page="attendees.length"
                :options.sync="attendee_pagination"
                :footer-props="{
                  'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                  'items-per-page-all-text': $t('global.items_per_page_all_text'),
                  'items-per-page-text': $t('global.items_per_page_text'),
                  'page-text': $t('global.page_text')
                }"
                :server-items-length="attendee_total"
                :loading="attendee_show_loading"
                :loading-text="$t('global.loading_text')"
                :no-data-text="$t('global.no_data_text')"
                :no-results-text="$t('global.no_results_text')"
                :must-sort="true"
              >
                <template v-slot:item.first_name="{ item }">
                  {{ item.participant.first_name }}
                </template>

                <template v-slot:item.last_name="{ item }">
                  {{ item.participant.last_name }}
                </template>

                <template v-slot:item.enrolled_organisation_id="{ item }">
                  {{ item.organisation.name }}
                </template>

                <template v-slot:item.enrolled_date="{ item }">
                  {{
                    moment.utc(item.enrolled_date).format(DATE_FORMAT) +
                    " " +
                    moment.utc(item.enrolled_date, TIME_FORMAT).format(TIME_FORMAT)
                  }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <router-link
                    :to="{ path: BACKEND_URL + '/attendees/view/' + item.id, props: { id: item.id } }"
                    v-if="$can('attendee-access')"
                  >
                    <action-button type="view" :icon_only="true" small />
                  </router-link>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>

        <v-dialog v-model="showDialogForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <component
              :is="currentLoadedForm.form"
              :id="currentLoadedForm.id"
              :moduletemplate_id="currentLoadedForm.moduletemplate_id"
              :moduleoption_id="currentLoadedForm.moduleoption_id"
              :coursetemplate_id="currentLoadedForm.coursetemplate_id"
              :coursetypes="currentLoadedForm.coursetypes"
              :modal="true"
              @return_modal_form="return_modal_form"
              @return_modal_cancel_form="return_modal_cancel_form"
            ></component>
          </div>
        </v-dialog>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseView",

  props: ["id", "modal"],

  components: {
    "moduleoption-form": () => import("../../moduleoptions/components/Form"),
    "moduleoptioncoursetype-form": () => import("../../moduleoptioncoursetypes/components/Form")
  },

  data() {
    return {
      page_title: "",
      course: {},
      coursetype: {},
      coursetemplate: {},
      classes: {},
      instructor: {},
      address: {},
      classroom: {},

      moduletemplates: [],

      currentFormId: "",
      currentModuleTemplateId: "",
      currentModuleOptionId: "",
      currentCourseTemplateId: "",
      currentCourseTypes: [],
      currentForm: "",
      showDialogForm: false,

      attendees: [],
      attendee_total: 0,
      attendee_show_loading: false,
      attendee_show_filter: false,
      attendee_refresh: false,
      attendee_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      attendee_headers: [
        { text: this.$t("participants.first_name"), value: "first_name" },
        { text: this.$t("participants.last_name"), value: "last_name" },
        { text: this.$t("attendees.enrolled_organisation_id"), value: "enrolled_organisation_id" },
        { text: this.$t("attendees.enrolled_date"), value: "enrolled_date" },
        { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end" }
      ]
    }
  },

  watch: {
    attendee_refresh: {
      handler() {
        if (this.attendee_refresh && this.course.id) {
          this.attendee_list()
        }
      }
    },
    attendee_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.attendee_refresh = true
      }
    }
  },

  computed: {
    computedCourseStartDate() {
      return this.course.start_date ? this.moment.utc(this.course.start_date).format(this.DATE_FORMAT) : ""
    },
    computedCourseStartTime() {
      return this.course.start_time ? this.moment.utc(this.course.start_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    },
    computedCourseEndDate() {
      return this.course.end_date ? this.moment.utc(this.course.end_date).format(this.DATE_FORMAT) : ""
    },
    computedCourseEndTime() {
      return this.course.end_time ? this.moment.utc(this.course.end_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    },
    currentLoadedForm: function () {
      let form,
        id,
        coursetypes,
        coursetemplate_id,
        moduletemplate_id,
        moduleoption_id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
        coursetypes = this.currentCourseTypes
        moduletemplate_id = this.currentModuleTemplateId
        moduleoption_id = this.currentModuleOptionId
        coursetemplate_id = this.currentCourseTemplateId
      }

      return {
        id: id,
        form: form,
        moduletemplate_id: moduletemplate_id,
        moduleoption_id: moduleoption_id,
        coursetemplate_id: coursetemplate_id,
        coursetypes: coursetypes
      }
    }
  },

  created() {
    axios
      .get(this.API_URL + "course/" + this.id)
      .then((res) => {
        this.course = res.data.data
        this.coursetype = this.course.coursetype
        this.coursetemplate = this.course.coursetemplate
        this.classes = this.course.class
        this.instructor = this.course.instructor
        this.address = this.course.address
        this.classroom = this.course.classroom

        this.page_title = this.$t("courses.view_course", { name: this.course.name })

        this.loadModuleTemplates()
        this.attendee_list()
      })
      .catch((err) => console.log(err))
  },

  methods: {
    attendee_list() {
      this.attendee_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.attendee_pagination
      let query = this.$queryString(this.attendee_pagination, { course_id: this.course.id })

      axios.get(this.API_URL + "attendees?" + query).then((res) => {
        this.attendees = res.data.data
        this.attendee_total = res.data.meta.total
        this.attendee_refresh = false
        this.attendee_show_loading = false

        this.attendee_pagination.page = res.data.meta.current_page
        this.attendee_pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    loadModuleTemplates() {
      let ctid = this.course.coursetemplate_id
      let vm = this

      axios
        .get(this.API_URL + "coursetemplate/" + ctid)
        .then((res) => {
          let coursetemplate = res.data.data

          this.moduletemplates = coursetemplate.moduletemplates
          this.moduletemplates.forEach(function (item) {
            item.module_options = item.module_options.filter((i) => i.coursetemplate_id == vm.course.coursetemplate_id)
          })

          this.currentCourseTypes = this.coursetemplate.coursetypes.map((a) => a.id)
        })
        .catch((err) => console.log(err))
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "course/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/courses")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoption/" + id)
            .then((res) => {
              vm.loadModuleTemplates()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option_ct(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoptioncoursetype/" + id)
            .then((res) => {
              vm.loadModuleTemplates()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    showForm(id, type, mid, cid) {
      this.currentFormId = id

      if (type == "moduleoption") this.currentModuleTemplateId = mid
      if (type == "moduleoptioncoursetype") this.currentModuleOptionId = mid

      this.currentCourseTemplateId = cid

      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.loadModuleTemplates()
    },
    return_modal_cancel_form() {
      this.currentForm = ""
      this.currentCourseTemplateId = ""
      this.currentModuleTemplateId = ""
      this.currentModuleOptionId = ""
      this.showDialogForm = false
    }
  }
}
</script>

<style scoped>
.form-modal {
  background: white;
}
.ct-td {
  padding: 9px !important;
  background: var(--v-secondary-base) !important;
}
.mt-card-title {
  background: var(--v-primary-base) !important;
}
</style>
